import React from 'react';
import { Card, CardContent, Box } from '@mui/material';
import ContentLoader from 'react-content-loader';

const SkeletonSettingsPage = () => (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {/* Header Card */}

        <ContentLoader
            speed={2}
            width="100%"
            height={70}
            backgroundColor="#524d52"
            foregroundColor="#3D393B"
        >
            <rect x="20" y="20" rx="5" ry="5" width="95%" height="60" />
        </ContentLoader>


        {/* General Settings Section Card */}
        <Card sx={{ backgroundColor: '#252224', width: '95%', ml: 3, borderRadius: '16px' }}>
            <CardContent>
                <ContentLoader
                    speed={2}
                    width="100%"
                    height={180}
                    backgroundColor="#3D393B"
                    foregroundColor="#4A494B"
                >
                    <rect y="20" rx="5" ry="5" width="30%" height="20" />
                    <rect y="60" rx="5" ry="5" width="20%" height="20" />
                    <rect y="100" rx="8" ry="8" width="15%" height="80" />
                </ContentLoader>
            </CardContent>
        </Card>

        {/* Preferences Section Card */}
        <Card sx={{ backgroundColor: '#252224', width: '95%', ml: 3, mt: 3, borderRadius: '16px' }}>
            <CardContent>
                <ContentLoader
                    speed={2}
                    width="100%"
                    height={125}
                    backgroundColor="#3D393B"
                    foregroundColor="#4A494B"
                >
                    <rect y="20" rx="4" ry="4" width="30%" height="20" />
                    <rect y="60" rx="4" ry="4" width="20%" height="20" />
                    <rect x="640" y="60" rx="4" ry="4" width="20%" height="20" />
                    {/* Email notifications */}
                    <rect y="100" rx="8" ry="8" width="80px" height="20" />
                    <rect x="100" y="100" rx="8" ry="8" width="80px" height="20" />
                    <rect x="200" y="100" rx="8" ry="8" width="80px" height="20" />
                    <rect x="300" y="100" rx="8" ry="8" width="80px" height="20" />
                    <rect x="400" y="100" rx="8" ry="8" width="80px" height="20" />
                    {/* Admin notifications */}
                    <rect x="640" y="100" rx="8" ry="8" width="80px" height="20" />
                    <rect x="740" y="100" rx="8" ry="8" width="80px" height="20" />
                </ContentLoader>
            </CardContent>
        </Card>

    </Box>
);

export default SkeletonSettingsPage;
